import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MaskVentilator = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M159.1 176c-19.7 43.2-31.1 88.7-31.1 124.8 0 15.9 2.2 31.4 6.3 46l-31.8-7.9c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h103.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6v-76.5c-19.7-16.4-32-40.3-32-66.9 0-49.5 43-134.4 96-134.4 52.5 0 96 84.9 96 134.4 0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1 0-36.1-11.6-81.6-31.3-124.8zM288 320v192h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
  }));
});
MaskVentilator.displayName = 'MaskVentilator';
export var MaskVentilatorDimensions = {
  height: 512,
  width: 640
};